<div class="container-sale" id="container-sale">
    <!-- Datos generales -->
    <div class="card mb-3 shadow-sm">
        <div class="card-header text-white">
        <h3 class="mb-0">Transferencia Internacional BAM</h3>
        </div>

        <div class="card-header bg-light">
        <h5 class="mb-0 fw-semibold text-primary">1. Datos generales</h5>
        </div>

        <div class="card-body row g-3">
        <div class="col-md-6 form-group">
            <label class="form-label fw-semibold">Cuenta bancaria a Debitar</label>
            <select class="form-select" [(ngModel)]="bankAccountNumberDebit">
            <option [ngValue]="null" disabled>Seleccione una cuenta</option>
            <option *ngFor="let account of filterAccountsDebit" [ngValue]="account.accountNumber">
                {{ account.alias }} - {{ account.accountNumber }}
            </option>
            </select>
        </div>

        <div class="col-md-6 form-group">
            <label class="form-label fw-semibold">Tipo de transferencia</label>
            <select class="form-select" [(ngModel)]="transferType">
            <option [ngValue]="1">Cuenta bancaria a terceros</option>
            <option [ngValue]="0">Cuenta bancaria propia</option>
            </select>
        </div>

        <!-- Cuenta propia -->
        <div class="col-md-6 form-group" *ngIf="transferType === 0">
        <label class="form-label fw-semibold">Cuenta bancaria destino</label>
        <select class="form-select" [(ngModel)]="bankAccountNumberCredit">
            <option [ngValue]="null" disabled>Seleccione una cuenta</option>
            <option
            *ngFor="let account of filterAccountsCredit"
            [ngValue]="account.accountNumber"
            [disabled]="account.accountNumber === bankAccountNumberDebit">
            {{ account.alias }} - {{ account.accountNumber }}
            </option>
        </select>
        </div>

        <!-- Cuenta a terceros -->
        <div class="col-12" *ngIf="transferType === 1">
        <div class="mb-3">
            <label class="form-label fw-semibold">Cliente</label>
            <div class="input-group input-group-sm">
            <app-input-autocomplete
                [ruleToDisabled]="clients.length == 0"
                [allBorderRadius]="true"
                [inputs]="client"
                [placeholder]="'Ingresa el NIT o nombre del cliente'"
                [filterElements]="client.filterElements"
                [typeElements]="'client'"
                (inputMethod)="writeClient()"
                (changeStatus)="selectClient($event.filterElement)"
                [custom]="true">
                <ng-template #itemsTemplate let-filter>
                <div items>
                    <h6 class="text-info mb-0">{{ filter.name }}</h6>
                    <small class="text-muted">NIT: <b>{{ filter.nit }}</b></small>
                </div>
                </ng-template>
            </app-input-autocomplete>
            </div>
        </div>

        <div *ngIf="clientSelected" class="card border-0 shadow-sm p-3 mb-3 bg-light">
            <div><strong>Nombre:</strong> {{ clientSelected.name }}</div>
            <div><strong>NIT:</strong> {{ clientSelected.nit }}</div>
            <div><strong>Código:</strong> {{ clientSelected.code }}</div>
        </div>

        <div class="form-group" *ngIf="clientSelected">
            <label class="form-label fw-semibold">Cuenta del cliente</label>
            <select class="form-select" [(ngModel)]="selectedClientBankAccount">
            <option [ngValue]="null" disabled>Seleccione una cuenta</option>
            <option *ngFor="let acc of vendorAccounts" [ngValue]="acc.accountNumber">
                {{ acc.accountNumber }} - {{ getBankName(acc.idBank) }}
            </option>
            </select>
        </div>
        </div>

        <div class="col-md-6 form-group">
            <label class="form-label fw-semibold">Monto</label>
            <div class="input-group">
            <span class="input-group-text">Q</span>
            <input
                class="form-control text-end"
                type="number"
                step="0.01"
                min="0"
                [(ngModel)]="amount"
                placeholder="0.00">
            </div>
        </div>

        <div class="col-12 form-group">
            <label class="form-label fw-semibold">Descripción</label>
            <input
            class="form-control"
            type="text"
            [(ngModel)]="description"
            placeholder="Ej. Pago internacional de servicios">
            <div class="fw-bold text-warning mt-1">
            <i class="fa fa-info-circle"></i> No se aceptan caracteres especiales, tildes o ñ Ñ.
            </div>
        </div>
        </div>
    </div>

    <!-- Datos del beneficiario -->
    <div class="card mb-3 shadow-sm">
        <div class="card-header bg-light">
        <h5 class="mb-0 fw-semibold text-primary">2. Datos del beneficiario</h5>
        </div>

        <div class="card-body row g-3">
        <div class="col-md-4 form-group">
            <label class="form-label fw-semibold">Relación con el beneficiario</label>
            <select class="form-select" [(ngModel)]="relationshipCode">
            <option [ngValue]="null" disabled>Seleccione una opción</option>
            <option *ngFor="let item of relationshipOptions" [ngValue]="item.id">
                {{ item.name }}
            </option>
            </select>
        </div>

        <div class="col-md-4 form-group" *ngIf="relationshipCode === 5">
            <label class="form-label fw-semibold">Detalle de relación</label>
            <input
            class="form-control"
            type="text"
            [(ngModel)]="relationShipOther"
            placeholder="Especifique la relación">
        </div>

        <div class="col-md-4 form-group">
            <label class="form-label fw-semibold">Tipo de beneficiario</label>
            <select class="form-select" [(ngModel)]="type" (ngModelChange)="clearPersonFieldsByType()">
            <option *ngFor="let item of personTypeOptions" [ngValue]="item.id">
                {{ item.name }}
            </option>
            </select>
        </div>

        <div class="col-md-4 form-group">
            <label class="form-label fw-semibold">País destino</label>
            <select class="form-select" [(ngModel)]="countryCode">
            <option [ngValue]="null" disabled>Seleccione un país</option>
            <option *ngFor="let country of countries" [ngValue]="country.id">
                {{ country.id }} - {{ country.name }}
            </option>
            </select>
        </div>

        <div class="col-md-4 form-group">
            <label class="form-label fw-semibold">Ciudad</label>
            <input
            class="form-control"
            type="text"
            [(ngModel)]="city"
            placeholder="Ciudad destino">
        </div>

        <div class="col-md-4 form-group">
            <label class="form-label fw-semibold">Dirección</label>
            <input
            class="form-control"
            type="text"
            [(ngModel)]="address"
            placeholder="Dirección completa del beneficiario">
        </div>

        <!-- Persona natural -->
        <ng-container *ngIf="isNaturalPerson()">
            <div class="col-md-3 form-group">
            <label class="form-label fw-semibold">Primer nombre</label>
            <input
                class="form-control"
                type="text"
                [(ngModel)]="firstName"
                placeholder="Primer nombre">
            </div>

            <div class="col-md-3 form-group">
            <label class="form-label fw-semibold">Segundo nombre</label>
            <input
                class="form-control"
                type="text"
                [(ngModel)]="secondName"
                placeholder="Segundo nombre">
            </div>

            <div class="col-md-3 form-group">
            <label class="form-label fw-semibold">Primer apellido</label>
            <input
                class="form-control"
                type="text"
                [(ngModel)]="surname"
                placeholder="Primer apellido">
            </div>

            <div class="col-md-3 form-group">
            <label class="form-label fw-semibold">Segundo apellido</label>
            <input
                class="form-control"
                type="text"
                [(ngModel)]="secondNameSurname"
                placeholder="Segundo apellido">
            </div>
        </ng-container>

        <!-- Persona juridica -->
        <ng-container *ngIf="isLegalPerson()">
            <div class="col-12 form-group">
            <label class="form-label fw-semibold">Nombre comercial</label>
            <input
                class="form-control"
                type="text"
                [(ngModel)]="comercialName"
                placeholder="Nombre de la compañía">
            </div>
        </ng-container>
        </div>
    </div>

    <!-- Datos bancarios / cumplimiento -->
    <div class="card mb-3 shadow-sm">
        <div class="card-header bg-light">
        <h5 class="mb-0 fw-semibold text-primary">3. Datos bancarios y cumplimiento</h5>
        </div>

        <div class="card-body row g-3">
        <div class="col-md-4 form-group">
            <label class="form-label fw-semibold">Tipo de banco</label>
            <select class="form-select" [(ngModel)]="bankType">
            <option [ngValue]="null" disabled>Seleccione una opción</option>
            <option *ngFor="let item of bankTypeOptions" [ngValue]="item.id">
                {{ item.name }}
            </option>
            </select>
        </div>

        <div class="col-md-4 form-group">
            <label class="form-label fw-semibold">Código del banco</label>
            <input
            class="form-control"
            type="text"
            [(ngModel)]="bankCode"
            placeholder="Código o SWIFT/BIC">
        </div>

        <div class="col-md-4 form-group">
            <label class="form-label fw-semibold">Tipo de comisión</label>
            <select class="form-select" [(ngModel)]="commsionCode">
            <option [ngValue]="null" disabled>Seleccione una opción</option>
            <option *ngFor="let item of commisionOptions" [ngValue]="item.id">
                {{ item.name }}
            </option>
            </select>
        </div>

        <div class="col-md-4 form-group">
            <label class="form-label fw-semibold">Motivo de egreso</label>
            <select class="form-select" [(ngModel)]="egressCode">
            <option [ngValue]="null" disabled>Seleccione una opción</option>
            <option *ngFor="let item of egressOptions" [ngValue]="item.id">
                {{ item.name }}
            </option>
            </select>
        </div>

        <div class="col-md-4 form-group" *ngIf="egressCode === 5">
            <label class="form-label fw-semibold">Detalle de egreso</label>
            <input
            class="form-control"
            type="text"
            [(ngModel)]="egressOther"
            placeholder="Especifique el motivo">
        </div>

        <div class="col-md-4 form-group">
            <label class="form-label fw-semibold">Procedencia de fondos</label>
            <select class="form-select" [(ngModel)]="procedenceCode">
            <option [ngValue]="null" disabled>Seleccione una opción</option>
            <option *ngFor="let item of procedenceOptions" [ngValue]="item.id">
                {{ item.id }} - {{ item.name }}
            </option>
            </select>
        </div>

        <div class="col-md-4 form-group">
            <label class="form-label fw-semibold">Detalle procedencia (opcional)</label>
            <input
            class="form-control"
            type="text"
            [(ngModel)]="procedenceOther"
            placeholder="Información adicional">
        </div>
        </div>
    </div>

    <div class="text-center mt-4">
        <button class="btn btn-success btn-lg px-5" (click)="openConfirmModal()" [disabled]="loading">
        <ng-container *ngIf="loading">
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            <span role="status"></span>
        </ng-container>
        <i class="fa fa-paper-plane me-2" *ngIf="!loading"></i>
        Enviar Transferencia Internacional
        </button>
    </div>
    </div>

    <app-modal-dialog
    [title]="'Confirmar Transferencia Internacional'"
    [show]="confirmModalVisible"
    [showHeader]="true"
    [showFooter]="false"
    size="lg"
    position="center"
    (closed)="onCancelTransfer()"
    (confirmed)="onConfirmTransfer()"
    >
    <div modal-body>
        <div class="alert alert-warning d-flex align-items-center">
        <i class="fa fa-exclamation-triangle me-2"></i>
        <span>Revisa cuidadosamente los datos antes de confirmar la transferencia.</span>
        </div>

        <p class="fs-5">
        <strong>Monto:</strong>
        <span class="text-success fw-bold">Q {{ transferPreview?.amount | number:'1.2-2' }}</span>
        </p>

        <p>
        <strong>Descripción:</strong>
        <span class="text-muted">{{ transferPreview?.description }}</span>
        </p>

        <div class="card shadow-sm mb-2">
        <div class="card-body p-2">
            <h6 class="fw-bold text-primary mb-1">Cuenta Origen</h6>
            <div *ngIf="transferPreview?.debitAccount">
            <div>{{ transferPreview.debitAccount.accountNumber }} - {{ transferPreview.debitAccount.alias }}</div>
            <small class="text-muted">
                {{ getBankName(transferPreview.debitAccount.bank) }}
            </small>
            </div>
        </div>
        </div>

        <div class="card shadow-sm mb-2">
        <div class="card-body p-2">
            <h6 class="fw-bold text-primary mb-1">Cuenta Destino</h6>
            <div>{{ transferPreview?.bankAccountNumberCredit }}</div>
        </div>
        </div>

        <div class="card shadow-sm mb-2">
        <div class="card-body p-2">
            <h6 class="fw-bold text-primary mb-2">Beneficiario</h6>
            <div><strong>Nombre:</strong> {{ transferPreview?.beneficiaryName }}</div>
            <div><strong>Relación:</strong> {{ transferPreview?.relationshipName }}</div>
            <div><strong>Tipo:</strong> {{ transferPreview?.personTypeName }}</div>
            <div><strong>País:</strong> {{ transferPreview?.countryName }}</div>
        </div>
        </div>

        <div class="card shadow-sm">
        <div class="card-body p-2">
            <h6 class="fw-bold text-primary mb-2">Datos bancarios / cumplimiento</h6>
            <div><strong>Tipo banco:</strong> {{ transferPreview?.bankTypeName }}</div>
            <div><strong>Comisión:</strong> {{ transferPreview?.commissionName }}</div>
            <div><strong>Egreso:</strong> {{ transferPreview?.egressName }}</div>
            <div><strong>Procedencia:</strong> {{ transferPreview?.procedenceName }}</div>
        </div>
        </div>

        <div class="card shadow-sm mb-2">
        <div class="card-body p-2">
            <h6 class="fw-bold text-primary mb-1">Código</h6>

            <div *ngIf="!showInputCode">
            <button class="btn btn-link" [disabled]="loadingSendCode" (click)="sendRequestCode()">
                Solicitar Código
                <span *ngIf="loadingSendCode" class="spinner-border spinner-border-sm me-2"></span>
            </button>
            </div>

            <div *ngIf="showInputCode">
            <div class="input-group">
                <input
                class="form-control"
                type="text"
                [(ngModel)]="code2fa">

                <button class="btn btn-success" (click)="pastClipboard()">
                <i class="fa fa-clipboard"></i>
                </button>
            </div>

            <button class="btn btn-link" [disabled]="loadingSendCode" (click)="sendRequestCode()">
                Volver a solicitar código
                <span *ngIf="loadingSendCode" class="spinner-border spinner-border-sm me-2"></span>
            </button>
            </div>
        </div>
        </div>

        <div class="row">
        <div class="card-body p-3">
            <div class="col">
            <button class="btn btn-secondary btn-block" (click)="onCancelTransfer()">
                Cancelar
            </button>

            <button
                class="btn btn-primary btn-block"
                (click)="onConfirmTransfer()"
                *ngIf="showInputCode && code2fa">
                Finalizar
            </button>
            </div>
        </div>
        </div>
    </div>
</app-modal-dialog>